/*
* Expectation:
* [{
*   field: 'my-field',
*   value: 'any-value-can-be-an-array',
*   type: 'array'
* }]
* the type will be any of the types that metaField allows
* */

import {MetaFieldTypes} from "@/enum";

export const getColumnNames = async (json) => {
    return new Promise((resolve, reject) => {
        try {
            json = JSON.parse(json);
        } catch(e) {
            console.log('could not parse JSON file', e);
            reject(e);
        }
        const {fields} = json;
        if(!fields || !fields.length) {
            console.log('json contains no fields')
            reject('at least one field is mandatary');
        }
        if(!Array.isArray(fields)) {
            console.log('fields must be an array', typeof fields);
            reject('fields must be an array');
        }
        validateColumns(fields);
        const names = fields.map(item => item.name);
        for(let i = 0; i < names.length; i++) {
            if(names[i].length < 3) {
                reject('Field names must be at least 3 characters long');
            }
        }
        return resolve(names);
    })
}

export const getData = async (json) => {
    return new Promise((resolve, reject) => {
        if(typeof json === 'string') {
            try {
                json = JSON.parse(json);
            } catch(error) {
                reject(error);
            }
        }
        resolve(json);
    })
}

const validateColumns = (fields) => {
    const allowedVals = Object.values(MetaFieldTypes);
    for(let i = 0; i < fields.length; i++) {
        const {type, name} = fields[i];
        if(!allowedVals.includes(type)) {
            throw new Error(`field type "${type}" of field "${name}" is not allowed`);
        }
    }
}